import { DeleteSharp, EditSharp } from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Container,
  Grid,
  IconButton,
  Modal,
  Stack,
  TextField,
  Tooltip,
  Typography
} from "@mui/material";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import {
  deleteMemberDeactiveReason,
  getPrimeMemberDeactiveReason,
  insertMemberDeactiveReason,
  updateMemberDeactiveReason
} from "src/api/commonapi";
import Page from "src/components/Page";
import { notification } from "src/utils/messages";
import Deletemodal from "./DeleteModal";
import CustomLoader from "src/components/CustomLoader";

export default function MemberDeactivateReason() {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 2
  };

  const [addEditModal, setAddEditModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [memberDeactivateReasonData, setMemberDeactivateReasonData] = useState({
    member_deactive_reason: ""
  });
  const [tableData, setTableData] = useState([]);
  const toggleAddEditModal = () => setAddEditModal(!addEditModal);
  const resetFormData = () => {
    setMemberDeactivateReasonData({
      member_deactive_reason: ""
    });
  };
  const [dvisible, setDvisible] = useState({ mval: false, id: 0 });
  const [response, setresponse] = useState(0);

  const handleSubmit = async (newData = undefined) => {
    if (newData != undefined ? newData : memberDeactivateReasonData.m_d_r_id != undefined) {
      // update
      if (
        (newData != undefined ? newData : memberDeactivateReasonData).member_deactive_reason != ""
      ) {
        let fnData = new FormData();
        fnData.append(
          "m_d_r_id",
          newData != undefined ? newData.m_d_r_id : memberDeactivateReasonData.m_d_r_id
        );
        fnData.append(
          "member_deactive_reason",
          newData != undefined
            ? newData.member_deactive_reason
            : memberDeactivateReasonData.member_deactive_reason
        );

        setLoading(true);
        let resp = await updateMemberDeactiveReason(fnData);
        if (resp.status != 0) {
          let notify = notification({
            type: resp.status == 0 ? "error" : "success",
            message: resp.message
          });
          notify();
          resetFormData();
          newData == undefined && toggleAddEditModal();
          getMeetingFeedbackForData();
        } else {
          let notify = notification({
            type: resp.status == 0 ? "error" : "success",
            message: resp.message
          });
          notify();
        }
        setLoading(false);
      } else {
        let notify = notification({
          type: "error",
          message: "Please Fill All Fields data"
        });
        notify();
      }
    } else {
      // Insert
      if (memberDeactivateReasonData.member_deactive_reason != "") {
        let fnData = new FormData();
        fnData.append("member_deactive_reason", memberDeactivateReasonData.member_deactive_reason);
        setLoading(true);
        let resp = await insertMemberDeactiveReason(fnData);
        if (resp.status != 0) {
          let notify = notification({
            type: resp.status == 0 ? "error" : "success",
            message: resp.message
          });
          notify();
          resetFormData();
          toggleAddEditModal();
          getMeetingFeedbackForData();
        } else {
          let notify = notification({
            type: resp.status == 0 ? "error" : "success",
            message: resp.message
          });
          notify();
        }
        setLoading(false);
      } else {
        let notify = notification({
          type: "error",
          message: "Please Fill All Fields data"
        });
        notify();
      }
    }
  };
  const deleteMemberDeactivateReasons = async (m_d_r_id) => {
    const resp = await deleteMemberDeactiveReason(m_d_r_id);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();

    if (resp.status == 1) {
      setresponse(response + 1);
      setDvisible({ mval: false, id: 0 });
    }
  };
  const getMeetingFeedbackForData = async () => {
    setLoading(true);
    let res = await getPrimeMemberDeactiveReason();
    setLoading(false);
    setTableData(res);
  };
  useEffect(() => {
    getMeetingFeedbackForData();
  }, [response]);

  const columns = [
    {
      name: "No",
      wrap: true,
      selector: (row, index) => index + 1,
      sortable: true,
      width: "70px"
    },
    {
      name: "Name",
      wrap: true,
      selector: (row) => row?.member_deactive_reason,
      sortable: true
    },
    {
      name: "Action",
      wrap: true,
      sortable: true,
      selector: (row) => (
        <>
          {row.is_deleted == 0 && (
            <>
              <Tooltip title="Edit">
                <IconButton
                  onClick={() => {
                    setMemberDeactivateReasonData({
                      member_deactive_reason: row.member_deactive_reason,
                      m_d_r_id: row.m_d_r_id
                    });
                    toggleAddEditModal();
                  }}
                >
                  <EditSharp color="warning" />
                </IconButton>
              </Tooltip>

              <Tooltip title="Delete">
                <IconButton
                  onClick={() => {
                    setDvisible({ mval: true, id: row.m_d_r_id });
                  }}
                >
                  <DeleteSharp color="error" />
                </IconButton>
              </Tooltip>
            </>
          )}
        </>
      )
    }
  ];

  return (
    <>
      <Deletemodal
        visible={dvisible}
        setVisible={setDvisible}
        deletefunc={deleteMemberDeactivateReasons}
      />

      <Page title="LVB Member Deactivate Reason | Local Vocal Business Group">
        <Container>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
                <Typography variant="h4" gutterBottom>
                  Member Deactivate Reason
                </Typography>
              </Stack>
            </Grid>
            <Grid item xs={6}>
              <Button
                onClick={() => (toggleAddEditModal(), resetFormData())}
                style={{ marginBottom: "15px", float: "right" }}
                variant="contained"
              >
                Add Member Deactivate Reason
              </Button>
            </Grid>
          </Grid>

          <Modal
            open={addEditModal}
            onClose={() => (toggleAddEditModal(), resetFormData())}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                style={{ marginBottom: "5px", textAlign: "center" }}
              >
                Add Member Deactivate Reason
              </Typography>
              <hr />
              <Stack spacing={10} style={{ marginBottom: "15px" }}>
                <Grid container>
                  <Grid item sm={12} xs={12}>
                    <TextField
                      style={{ marginTop: "15px" }}
                      height={10}
                      fullWidth
                      autoComplete="off"
                      type="text"
                      label="Member Deactivate Reason"
                      name="member_deactive_reason"
                      placeholder="Enter Member Deactivate Reasonn"
                      onChange={(e) => {
                        setMemberDeactivateReasonData({
                          ...memberDeactivateReasonData,
                          member_deactive_reason: e.target.value
                        });
                      }}
                      value={memberDeactivateReasonData?.member_deactive_reason}
                    />
                  </Grid>
                  <Grid
                    item
                    sm={12}
                    xs={12}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center"
                    }}
                  >
                    <Button
                      variant="outlined"
                      onClick={() => (toggleAddEditModal(), resetFormData())}
                      style={{ marginTop: "15px", marginRight: "15px" }}
                    >
                      Close
                    </Button>
                    <Button
                      variant="contained"
                      style={{ marginTop: "15px" }}
                      onClick={() => handleSubmit()}
                      disabled={loading}
                      startIcon={loading && <CircularProgress size={20} color="inherit" />}
                    >
                      Submit
                    </Button>
                  </Grid>
                </Grid>
              </Stack>
            </Box>
          </Modal>

          <Card spacing={3} style={{ padding: "10px", marginTop: "20px" }}>
            <DataTable
              filter
              pagination
              highlightOnHover
              columns={columns}
              data={tableData != null ? tableData : []}
              progressPending={loading}
              progressComponent={<CustomLoader />}
            />
          </Card>
        </Container>
      </Page>
    </>
  );
}
